// External libraries
import React from 'react';
// @ts-expect-error checkout/react-components
import { LoadingSpinner } from '@checkout/react-components';

// Internal modules
// @ts-expect-error TODO:  lazyLoader
import { lazyLoader } from '@/lib';
import { SelectAllTerms } from './SelectAllTerms';
import type { GenericObjectType } from '@/types';

const LazySelectAllTerms = lazyLoader({
  loader: () => import('./SelectAllTerms'),
  loading: () => <LoadingSpinner />,
  name: 'select_all_terms',
  render(_: unknown, props: GenericObjectType) {
    return <SelectAllTerms {...props} />;
  },
});

export { LazySelectAllTerms };
